// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"46a92b5071e9a2ff","397":"7d5043bf9cb8cefe","777":"445000e279679606","851":"16ee31c0503c8a8e"}[chunkId] + ".js";
};